export const SPINNER_OPEN = 'SPINNER_OPEN';
export const SPINNER_CLOSE = 'SPINNER_CLOSE';
export const SPINNER_DEFAULT_MESSAGE_TYPE = 'base.processing';
